import React from 'react';
import PropTypes from 'prop-types';
import cx from 'src/classnames';
import styles from './H2.module.scss';

const H2 = ({ children, className, customStyle }) => {
  return <h2 className={cx(customStyle ? '' : styles.h2, className)}>{children}</h2>;
};

H2.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  className: PropTypes.string,
  customStyle: PropTypes.bool,
};

export default H2;
